export default __webpack_public_path__ + "static/media/椭圆形.788024a5.png";